import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../api'; // Use central api instance

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const toastId = toast.loading("Sending request...");

        try {
            const response = await api.post('/vres/auth/forgot-password', {
                email: email
            });

            console.log("Forgot password response:", response);

            toast.update(toastId, { render: "OTP request sent! Check your email if the account exists.", type: "success", isLoading: false, autoClose: 3000 });

            navigate(`/reset-password?email=${email}`);

        } catch (error) {
            console.error("Forgot password API error:", error);

            let displayMessage = "An error occurred. Please try again later.";

            if (error.response && error.response.data && error.response.data.message) {
                displayMessage = error.response.data.message;
            }
            else if (error.response && error.response.status === 404) {
                 displayMessage = "User not found with that email address.";
             }
            else if (error.message) {
                displayMessage = `Request failed: ${error.message}`;
            }

            toast.update(toastId, { render: displayMessage, type: "error", isLoading: false, autoClose: 3000 });
        }
    };

    // --- STYLES INJECTION ---
    const PageStyleBlock = () => (
        <style>{`
            .fp-input:focus {
                border-color: #20c997 !important;
                box-shadow: 0 0 0 3px rgba(32, 201, 151, 0.1) !important;
                outline: none;
            }
            .fp-btn:hover:not(:disabled) { opacity: 0.9; }
            .fp-btn:disabled { opacity: 0.6; cursor: not-allowed; }
            .fp-link:hover { text-decoration: underline; color: #0056b3; }
        `}</style>
    );

    return (
        <div style={styles.formWrapper}>
            <PageStyleBlock />
            
            <div style={styles.formCard}>
                <h2 style={styles.formTitle}>Forgot Password</h2>
                <p style={{ textAlign: 'center', color: '#636e72', marginBottom: '25px', fontSize: '0.9rem' }}>
                    Enter your email address to receive a verification code.
                </p>

                <form onSubmit={handleSubmit}>
                    <div style={styles.formGroup}>
                        <label htmlFor="email" style={styles.formLabel}>Email Address</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your registered email"
                            className="fp-input"
                            style={styles.formControl}
                            required
                            autoFocus
                        />
                    </div>

                    <div style={styles.btnGroup}>
                        <button 
                            type="submit" 
                            className="fp-btn"
                            style={{ ...styles.btn, ...styles.btnPrimary }}
                        >
                            Send OTP
                        </button>
                    </div>

                    <div style={{ marginTop: "20px", textAlign: "center", fontSize: "0.9rem" }}>
                        <Link to="/login" className="fp-link" style={{ color: "#007bff", textDecoration: "none", fontWeight: "600" }}>
                            ← Back to Login
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
};

// --- STYLES (Consistent with Teal Theme) ---
const styles = {
    formWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center', 
        width: '100%',
        minHeight: '100vh', // Full viewport height for auth pages
        padding: '20px',
        boxSizing: 'border-box',
        fontFamily: "'Segoe UI', Roboto, sans-serif",
        backgroundColor: '#f0fdf9', // ✅ Teal Background
    },
    formCard: {
        background: 'white',
        width: '100%',
        maxWidth: '450px', // Compact card for simple form
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
        borderTop: '5px solid #20c997', // ✅ Teal Border
        margin: '0 auto',
    },
    formTitle: {
        textAlign: 'center',
        marginBottom: '10px',
        fontSize: '1.5rem',
        color: '#007bff', 
        fontWeight: '700',
        marginTop: 0,
    },
    formGroup: {
        marginBottom: '20px',
    },
    formLabel: {
        display: 'block',
        marginBottom: '8px',
        fontWeight: '600',
        color: '#2d3436', 
        fontSize: '0.9rem',
    },
    formControl: {
        width: '100%',
        padding: '12px 15px',
        border: '1px solid #dcdcdc',
        borderRadius: '6px',
        fontSize: '0.95rem',
        transition: 'all 0.3s',
        outline: 'none',
        boxSizing: 'border-box',
        color: '#2d3436',
        backgroundColor: '#fff',
    },
    btnGroup: {
        marginTop: '20px',
    },
    btn: {
        width: '100%',
        padding: '12px',
        borderRadius: '6px',
        fontSize: '1rem',
        fontWeight: '600',
        cursor: 'pointer',
        border: 'none',
        transition: 'opacity 0.2s',
    },
    btnPrimary: {
        backgroundColor: '#007bff', 
        color: 'white',
    },
};

export default ForgotPasswordPage;